import { SxProps, Theme } from "@mui/material/styles";

import { ICD10Code } from "services/icd10-codes";

export const INACTIVE_ICD10_CODE_TOOLTIP =
  "This ICD-10 code is inactive. Remove or replace it, or the note won't save.";

// The global MuiChip `filled` styleOverride (app/themes/components/chip.ts)
// paints every filled chip lavender regardless of `color`, so the error look
// must be forced through sx.
export const INACTIVE_ICD10_CHIP_SX: SxProps<Theme> = {
  background: (theme: Theme) => theme.palette.error.main,
  color: "error.contrastText",
  "& .MuiSvgIcon-root": { color: "error.contrastText" },
  "& .MuiChip-deleteIcon": {
    color: "error.contrastText",
    opacity: 0.7,
    "&:hover": { color: "error.contrastText", opacity: 1 }
  }
};

// Only an explicit false counts as inactive — search results and older cached
// payloads may omit the field entirely.
export const isInactiveICD10Code = (code: ICD10Code): boolean =>
  code.is_active === false;

export const inactiveIcd10ReplacementsTestId = (code: string) =>
  `inactive_icd10_replacements_${code}`;

// What an ICD-10-CM code looks like (H61.2, H90.A11, E11, Z01.118): the exact-code
// lookup below is only worth a request for text shaped like one.
const ICD10_CODE_SHAPE = /^[A-Z][0-9][0-9A-Z](\.[0-9A-Z]{1,4})?$/;
export const looksLikeIcd10Code = (text: string) => ICD10_CODE_SHAPE.test(text);
